import React from 'react'
import type { HTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'

import {
  IconPriorityHigh,
  IconPriorityMedium,
  IconPriorityLow,
} from 'components/Icons'

export interface PriorityLabelProps extends HTMLAttributes<HTMLDivElement> {
  status: string
  className?: string
  classNameText?: string
}

function PriorityLabel(props: PriorityLabelProps): JSX.Element {
  const { t } = useTranslation('common')

  const base = 'priority'
  const { status, className, classNameText } = props

  let label = t('low.label')
  let icon = (
    <IconPriorityLow
      data-testid={`${base}-low`}
      className={`${base}__icon--low`}
      variants='xs'
    />
  )

  switch (status.toLowerCase()) {
    case 'medium':
      icon = (
        <IconPriorityMedium
          data-testid={`${base}-medium`}
          className={`${base}__icon--medium`}
          variants='xs'
        />
      )
      label = t('medium.label')

      break

    case 'high':
      icon = (
        <IconPriorityHigh
          data-testid={`${base}-high`}
          className={`${base}__icon--high`}
          variants='xs'
        />
      )
      label = t('high.label')

      break
  }

  return (
    <div className={`${base}__label ${className}`}>
      {icon}
      <label
        className={`${base}__title ${classNameText}`}
        data-testid={`${base}-label`}
      >
        {label}
      </label>
    </div>
  )
}

export default PriorityLabel
